export default __webpack_public_path__ + "static/media/about.be250b2a.jpg";